var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Proveedor de GPS" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ProveedorForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              proveedorSeleccionado: _vm.lstProveedor.data,
              modoVer: true
            }
          }),
          _c("ClienteProveedorGrid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarProveedor.step,
                expression: "pasoActivoIndex === pasos.asociarProveedor.step"
              }
            ],
            attrs: {
              modoVer: true,
              proveedorSeleccionado: _vm.lstProveedor.data
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }